import http from "@/common/utils/http"
import { HttpRequestConfig } from "@repo/http"

import type {
	IExchangeRateData,
	IFuturesData,
	IIndexData,
	ILBMAPricesResponse,
	PreciousMetalType,
	ProductListResponse,
} from "./interface"

type IParams = {
	precious_type?: PreciousMetalType | null
}
/**
 * 1.0 获取 LBMA 定盘价
 * GET /spotoverseascenter/v1/precious/prices/lbma
 */
export const getLBMAPrices = async (precious_type?: PreciousMetalType | null) => {
	const httpConfig: HttpRequestConfig<IParams> = {
		params: { precious_type },
	}
	return await http
		.get<IParams, ILBMAPricesResponse[]>(`/spotoverseascenter/v1/precious/prices/lbma`, httpConfig)
		.catch(() => [] as ILBMAPricesResponse[])
}

/**
 * 1.1 获取价格点数据
 * GET /spotoverseascenter/v1/precious/prices
 * @param params.precious_type 贵金属类型
 * @param params.currency_type 货币类型 1:Origin 2:切换后的价格(美元价格) 不传值默认原价格
 */
export const getProductList = async (params: { precious_type?: PreciousMetalType; currency_type?: number }) => {
	const httpConfig: HttpRequestConfig<{ precious_type?: PreciousMetalType; currency_type?: number }> = {
		params,
	}
	return await http
		.get<
			{ precious_type?: PreciousMetalType; currency_type?: number },
			ProductListResponse[]
		>(`/spotoverseascenter/v1/precious/prices`, httpConfig)
		.catch(() => [] as ProductListResponse[])
}

/**
 * 1.2 获取期货数据（按交易所 second_name：shfe / lme）
 * GET /spotoverseascenter/v1/precious/prices/futures
 */
export const getFuturesData = async (precious_type?: PreciousMetalType | null) => {
	const httpConfig: HttpRequestConfig<IParams> = {
		params: { precious_type },
	}
	return await http
		.get<IParams, IFuturesData>(`/spotoverseascenter/v1/precious/prices/futures`, httpConfig)
		.catch(() => ({ prices: [] }) as IFuturesData)
}

/**
 * 1.3 获取贵金属指数
 * GET /spotoverseascenter/v1/precious/prices/index
 */
export const getSpotOverseasIndex = async (precious_type?: PreciousMetalType | null) => {
	const httpConfig: HttpRequestConfig<IParams> = {
		params: { precious_type },
	}
	return await http
		.get<IParams, IIndexData[]>(`/spotoverseascenter/v1/precious/prices/index`, httpConfig)
		.catch(() => [] as IIndexData[])
}

/**
 * 1.4 获取汇率
 * GET /spotoverseascenter/v1/precious/prices/exchange_rate
 */
export const getSpotOverseasExchangeRate = async () => {
	const httpConfig: HttpRequestConfig<null> = {}
	return await http
		.get<null, IExchangeRateData[]>(`/spotoverseascenter/v1/precious/prices/exchange_rate`, httpConfig)
		.catch(() => [] as IExchangeRateData[])
}
